import { render, staticRenderFns } from "./EsDataCard.vue?vue&type=template&id=21cc75d2&scoped=true&"
import script from "./EsDataCard.vue?vue&type=script&lang=js&"
export * from "./EsDataCard.vue?vue&type=script&lang=js&"
import style0 from "./EsDataCard.vue?vue&type=style&index=0&id=21cc75d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc75d2",
  null
  
)

export default component.exports